import React from "react";
import { Link } from "react-router-dom";
import { ACCEPT_PAGES, CONVERT_PAGES, BUSINESS_PAGES } from "../lib/seoContent";
import { COUNTRY_PAGES } from "../lib/countries";

const Col = ({ title, children }) => (
  <div>
    <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600 mb-3">{title}</div>
    <ul className="space-y-2">{children}</ul>
  </div>
);

const L = ({ to, children }) => (
  <li>
    <Link to={to} className="text-[12px] text-zinc-600 hover:text-zinc-200 transition-colors lowercase">
      {children}
    </Link>
  </li>
);

// SEO interlinking mesh — compact 4-column strip inside the shared Footer.
// Guides / compare links live in the main footer columns, not here.
export const ExploreLinks = () => (
  <div data-testid="explore-links" className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-x-8 gap-y-8">
    <Col title="accept crypto">
      {ACCEPT_PAGES.slice(0, 6).map((p) => (
        <L key={p.slug} to={`/accept/${p.slug}`}>accept {p.name.toLowerCase()}</L>
      ))}
      <L to="/accept">all 19 coins →</L>
    </Col>
    <Col title="for your business">
      {BUSINESS_PAGES.slice(0, 6).map((p) => (
        <L key={p.slug} to={`/accept-crypto-for/${p.slug}`}>for {p.noun}</L>
      ))}
      <L to="/accept-crypto-for">all business types →</L>
    </Col>
    <Col title="by country">
      {COUNTRY_PAGES.slice(0, 6).map((c) => (
        <L key={c.slug} to={`/accept-crypto-in/${c.slug}`}>{c.name}</L>
      ))}
      <L to="/countries">all countries →</L>
    </Col>
    <Col title="live conversions">
      {CONVERT_PAGES.slice(0, 4).map((p) => (
        <L key={p.slug} to={`/convert/${p.slug}`}>{p.sym.toLowerCase()} to usd</L>
      ))}
      <L to="/convert/btc-to-inr">btc to inr</L>
      <L to="/convert/eth-to-eur">eth to eur</L>
      <L to="/convert">all converters →</L>
    </Col>
    <Col title="price predictions">
      {ACCEPT_PAGES.filter((p) => !p.stable).slice(0, 6).map((p) => (
        <L key={p.slug} to={`/price-prediction/${p.slug}`}>{p.name.toLowerCase()} prediction</L>
      ))}
      <L to="/price-prediction">all predictions →</L>
    </Col>
    <Col title="compare gateways">
      <L to="/coinbase-commerce-alternative">vs coinbase commerce</L>
      <L to="/bitpay-alternative">vs bitpay</L>
      <L to="/nowpayments-alternative">vs nowpayments</L>
      <L to="/coingate-alternative">vs coingate</L>
      <L to="/stripe-crypto-alternative">vs stripe crypto</L>
      <L to="/best-crypto-payment-gateway">best gateways 2026</L>
      <L to="/compare">all comparisons →</L>
    </Col>
  </div>
);

export default ExploreLinks;
